import { render, staticRenderFns } from "./PrintLabelBarcodeView.vue?vue&type=template&id=4f139f96"
import script from "./PrintLabelBarcodeView.vue?vue&type=script&lang=js"
export * from "./PrintLabelBarcodeView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports